import { render, staticRenderFns } from "./CoreAdminLink.vue?vue&type=template&id=3d4ebd24&"
import script from "./CoreAdminLink.vue?vue&type=script&setup=true&lang=ts&"
export * from "./CoreAdminLink.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d4ebd24')) {
      api.createRecord('3d4ebd24', component.options)
    } else {
      api.reload('3d4ebd24', component.options)
    }
    module.hot.accept("./CoreAdminLink.vue?vue&type=template&id=3d4ebd24&", function () {
      api.rerender('3d4ebd24', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/core/CoreAdminLink/CoreAdminLink.vue"
export default component.exports